import { Button } from "./ui/button";
import { LogIn, LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { ChangePasswordDialog } from "./ChangePasswordDialog";
import { AccountsDialog } from "./AccountsDialog";

export const AuthButton = () => {
  const { user, logout, setAuthOpen } = useAuth();

  if (user)
    return (
      <div className="flex flex-wrap items-center gap-2 sm:gap-3">
        <span className="label-tech hidden xl:inline" data-testid="current-user-email">
          {user.email}
        </span>
        {user.role === "admin" && <AccountsDialog />}
        <ChangePasswordDialog />
        <Button
          variant="outline"
          data-testid="logout-btn"
          onClick={async () => {
            await logout();
            toast.success("Signed out");
          }}
          className="h-9 rounded-sm border-[#262626] bg-transparent hover:bg-[#1F1F1F] uppercase tracking-widest text-xs gap-2"
        >
          <LogOut className="w-4 h-4" />
          Sign Out
        </Button>
      </div>
    );

  return (
    <Button
      data-testid="login-btn"
      onClick={() => setAuthOpen(true)}
      className="h-9 rounded-sm bg-[#007AFF] hover:bg-[#0062cc] text-white uppercase tracking-widest text-xs gap-2"
    >
      <LogIn className="w-4 h-4" />
      Sign In
    </Button>
  );
};
